import { useTranslation } from "react-i18next";
import { NUMERATION_SCHEMA_ENDPOINT } from "../../../consts";
import { buildNumerationSchemaFieldAttributes } from "../../../workspaces/tenantConfig/numerationSchema.config";
import { NumerationSchema } from "../../../types/numerationSchemas";
import DynamicForm from "../dynamicForm/dynamicForm.component";
import CustomModal from "../modal/modal.component";

interface AddNumerationSchemaModalProps {
  opened: boolean;
  setOpened: (value: boolean) => void;
  /** The saved schema - the picker that opened the window selects it. */
  onCreated: (schema: NumerationSchema) => void;
}

/** "Add numeration schema" opened from a schema picker in another form - the
 *  same form as in Configuration → Numbering, stacked over that form. */
export default function AddNumerationSchemaModal({
  opened,
  setOpened,
  onCreated,
}: AddNumerationSchemaModalProps) {
  const { t } = useTranslation();

  const handleSuccess = (schema?: NumerationSchema) => {
    setOpened(false);
    window.dispatchEvent(new Event("numerationSchemasUpdated"));
    if (schema) onCreated(schema);
  };

  return (
    <CustomModal
      opened={opened}
      setOpened={setOpened}
      title={t("Add numeration schema")}
      content={
        <DynamicForm
          url={NUMERATION_SCHEMA_ENDPOINT}
          onSuccess={handleSuccess}
          fieldAttributes={buildNumerationSchemaFieldAttributes(t)}
        />
      }
    />
  );
}
